import { computed } from 'vue';
import { GetUserData } from '~/constants/getters';
import { hasAnyRole } from '~/utils/roles';

/**
 * Hides or disable an ui element based on binding.arg
 * Usability: v-has-access-by-role:hide="['admin']" or v-has-access-by-role:disabled="['admin']"
 * @param {HTMLElement} 'el' - current html element
 * @param {Object} 'binding' - values sent to the directive
 */

export default {
  mounted(el, binding) {
    const roles = computed(() => binding.instance.$store.getters[`authStore/${GetUserData}`].roles || []);

    const role = binding.value.role;

    if (!role) {
      return;
    }

    const hasAccess = hasAnyRole(roles.value, role);

    if (!hasAccess) {
      if (binding.arg === 'hide') {
        el.style.display = 'none'; // Hide the element
      } else if (binding.arg === 'disabled') {
        el.style.pointerEvents = 'none'; // Disable the element
        el.style.opacity = '1';
        el.style.backgroundColor = 'transparent';
        el.style.border = '1px solid #e8e7e5';
      }
    }
  },
};
